import { get, post } from './common'

type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>
type ApiBasePageResult<T> = ApiTypes.ApiBasePageResult<T>

export namespace courseware {
  // 保存课件
  export function save(data: PostData.Courseware.SaveModal) {
    return post<ApiBaseResult<ServerData.Courseware.SaveData>>('/courseware/save', {}, { ...data })
  }

  // 获取课件
  export function one(coursewareId: number) {
    return get<ApiBaseResult<ServerData.Courseware.DetailData>>('/courseware/one', { coursewareId })
  }

  // 获取课件列表
  export function search(data: PostData.Courseware.SearchModal) {
    return get<ApiBasePageResult<ServerData.Courseware.SearchData>>('/courseware/search', {
      ...data,
    })
  }

  // 上传附件
  export function uploadFile(data: PostData.Courseware.uploadFileModel) {
    return post<ApiBaseResult<ServerData.Courseware.UploadFileData>>(
      '/attachment/save_path',
      {},
      {
        ...data,
      }
    )
  }

  // 删除教案
  export function updateTeachPlanFile(coursewareId: number, teachingPlanId?: string) {
    return post<ApiBaseResult<null>>(
      '/courseware/teaching_plan_update',
      {},
      { coursewareId, teachingPlanId }
    )
  }

  // 删除附件
  export function updateOriginalFile(coursewareId: number, originalFileId?: string) {
    return post<ApiBaseResult<null>>(
      '/courseware/original_file_update',
      {},
      { coursewareId, originalFileId }
    )
  }

  // 删除课件
  export function del(coursewareId: number) {
    return post<ApiBaseResult<null>>('/courseware/delete', {}, { coursewareId })
  }
}
